module.exports = __webpack_public_path__ + "ei_transfers_icon.svg?9937fe299a20352c40244f96e08d032b";


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images/ei_transfers_icon.svg
// module id = 1122
// module chunks = 37